import { FC } from 'react';
import CodeIcon from '@mui/icons-material/Code';
import { IEntityContentField } from '../../../lib/interfaces/Common';
import ContentTitleWithIcon from '../../Simple/ContentTitle/ContentTitleWithIcon';
import ContentRenderer from '../Content/ContentRenderer';
import CodeSandPackAdapter from './CodeSandPackAdapter';

type CodeSandpackWithContentType = {
	field: IEntityContentField;
};

const CodeSandpackWithContent: FC<CodeSandpackWithContentType> = ({
	field,
}) => (
	<div>
		{field.options?.heading && (
			<ContentTitleWithIcon
				id={field.id}
				content={field.options.heading}
				icon={CodeIcon}
				className="content-column"
			/>
		)}
		{field.options?.contentBefore && (
			<div style={{ paddingBottom: 10 }}>
				<ContentRenderer
					html={field.options.contentBefore}
					className="content-column"
				/>
			</div>
		)}
		<CodeSandPackAdapter field={field} />
		{field.options?.contentAfter && (
			<div style={{ paddingTop: 10 }}>
				<ContentRenderer
					html={field.options.contentAfter}
					className="content-column"
				/>
			</div>
		)}
	</div>
);

export default CodeSandpackWithContent;
